var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadSearchComponents)?_c('property-search-module',{attrs:{"property-search-route":_vm.propertySearchRoute,"property-details-route":_vm.propertyDetailsRoute,"search-config":{
        apiPath: 'elasticsearch'
    },"default-location-overwrite":_vm.defaultLocation,"primary-filters":[
        'price',
        'beds',
        'sale' ],"active-action-buttons":_vm.activeActionButtons,"favorite-option-enabled":false,"tab-display":false,"filterable":_vm.filterable,"toggleable":_vm.toggleable}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }